export default import.meta.ROLLUP_FILE_URL_L68yeaTsw2kGgHcpbkZsCQ